import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const PRESETS = [
  { value: "up_to_today", label: "Up to Today" },
  { value: "this_week", label: "This Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "custom", label: "Custom Range" },
];

export default function DateRangeFilter({
  preset, startDate, endDate,
  onChange, // (next: { preset, start_date, end_date }) => void
  testidPrefix = "date-range",
}) {
  const update = (patch) => onChange({ preset, start_date: startDate, end_date: endDate, ...patch });
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="w-44" data-testid={`${testidPrefix}-preset-wrap`}>
        <Select
          value={preset}
          onValueChange={(v) => update({ preset: v, ...(v !== "custom" ? { start_date: "", end_date: "" } : {}) })}
        >
          <SelectTrigger data-testid={`${testidPrefix}-preset`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PRESETS.map((p) => (
              <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {preset === "custom" && (
        <>
          <input
            type="date"
            value={startDate || ""}
            onChange={(e) => update({ start_date: e.target.value })}
            data-testid={`${testidPrefix}-start`}
            className="border border-gray-300 rounded-md px-2 py-1.5 text-sm h-9"
          />
          <span className="text-xs text-gray-400">→</span>
          <input
            type="date"
            value={endDate || ""}
            onChange={(e) => update({ end_date: e.target.value })}
            data-testid={`${testidPrefix}-end`}
            className="border border-gray-300 rounded-md px-2 py-1.5 text-sm h-9"
          />
        </>
      )}
    </div>
  );
}
